import {useFragment} from 'react-relay';

export default function useAgGridDeletingRowFragment(fragment, queryData) {
  const data = useFragment(fragment, queryData);

  if (!data) return {};

  return data;
}
